const VIDEO_EXTENSIONS = ['mp4', 'mov', 'wmv', 'm4v', 'webm'];

const getExtension = (value) => {
    const path = String(value || '').split(/[?#]/)[0];
    return path.includes('.') ? path.split('.').pop().toLowerCase() : '';
};

// A Drive link is a viewer page, not a video file.
const isDriveLink = (source) => /^https?:\/\/drive\.google\.com\//i.test(String(source || ''));

// True for assets that should open in the in-app video player. Legacy assets
// still hosted on Google Drive are excluded so they keep opening in Drive.
export const isVideoAsset = (asset) => {
    if (!asset || isDriveLink(asset.source)) return false;
    return (
        asset.type === 'Tutorial Videos' ||
        VIDEO_EXTENSIONS.includes(getExtension(asset.name)) ||
        VIDEO_EXTENSIONS.includes(getExtension(asset.source))
    );
};
